import { z } from 'zod'

const EvidenceSessionStatusEnum = z.enum(['PENDING', 'SUBMITTED', 'APPROVED', 'CLOSED'])

export const evidenceSessionStatuses = EvidenceSessionStatusEnum.options

export const evidenceSessionEvidenceItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.string(),
})

export const evidenceSessionSchema = z.object({
  approvedDateTime: z.string().nullable().optional(),
  attributes: z
    .object({
      claimAmountInPence: z.number().optional(),
      approvedAmountInPence: z.number().optional(),
    })
    .catchall(z.unknown())
    .optional(),
  confirmedDateTime: z.string().nullable().optional(),
  created: z.string(),
  evidence: z.array(evidenceSessionEvidenceItemSchema),
  id: z.string(),
  memberId: z.string(),
  ref: z.string(),
  status: EvidenceSessionStatusEnum,
  updated: z.string().optional(),
})

export type EvidenceSessionStatus = z.infer<typeof EvidenceSessionStatusEnum>

// the endpoint returns the evidence session unwrapped, not nested under an `evidenceSession` key
export const getEvidenceSessionResponseSchema = evidenceSessionSchema

export type EvidenceSessionEvidenceItem = z.infer<typeof evidenceSessionEvidenceItemSchema>
export type EvidenceSession = z.infer<typeof evidenceSessionSchema>
export type GetEvidenceSessionResponse = z.infer<typeof getEvidenceSessionResponseSchema>
